export const USER_LOGOUT_REQUEST = "AUTH_WRAPPER/USER_LOGOUT_REQUEST";
export const USER_LOGOUT_SUCCESS = "AUTH_WRAPPER/USER_LOGOUT_SUCCESS";
export const USER_LOGOUT_FAILURE = "AUTH_WRAPPER/USER_LOGOUT_FAILURE";

export const LOAD_USER_REQUEST = "AUTH_WRAPPER/LOAD_USER_REQUEST";
export const LOAD_USER_SUCCESS = "AUTH_WRAPPER/LOAD_USER_SUCCESS";
export const LOAD_USER_FAILURE = "AUTH_WRAPPER/LOAD_USER_FAILURE";

export const GET_USER_NOTICE_REQUEST = "AUTH_WRAPPER/GET_USER_NOTICE_REQUEST";
export const GET_USER_NOTICE_SUCCESS = "AUTH_WRAPPER/GET_USER_NOTICE_SUCCESS";
export const GET_USER_NOTICE_FAILURE = "AUTH_WRAPPER/GET_USER_NOTICE_FAILURE";

export const SEE_USER_NOTICE_REQUEST = "AUTH_WRAPPER/SEE_USER_NOTICE_REQUEST";
export const SEE_USER_NOTICE_SUCCESS = "AUTH_WRAPPER/SEE_USER_NOTICE_SUCCESS";
export const SEE_USER_NOTICE_FAILURE = "AUTH_WRAPPER/SEE_USER_NOTICE_FAILURE";

export const UNAUTHORIZED_RESPONSE_ERROR = "UNAUTHORIZED_RESPONSE_ERROR";

export const SET_DAILY_REPORT_FILTER_DATA = "SET_DAILY_REPORT_FILTER_DATA";
export const RESET_DAILY_REPORT_FILTER_DATA = "RESET_DAILY_REPORT_FILTER_DATA";

export const SET_DENTIST_DETAILS_FILTER_DATA = "SET_DENTIST_DETAILS_FILTER_DATA";
export const RESET_DENTIST_DETAILS_FILTER_DATA = "RESET_DENTIST_DETAILS_FILTER_DATA";


export const REMOVE_USER_NOTICE_REQUEST = "AUTH_WRAPPER/REMOVE_USER_NOTICE_REQUEST";
export const REMOVE_USER_NOTICE_SUCCESS = "AUTH_WRAPPER/REMOVE_USER_NOTICE_SUCCESS";
export const REMOVE_USER_NOTICE_FAILURE = "AUTH_WRAPPER/REMOVE_USER_NOTICE_FAILURE";



// WEBPACK FOOTER //
// ./src/containers/AuthWrapper/constants.js